import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import ContraConchPiercingImage from '../../Assets/Piercing Services/Contra conch Piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function ContraConchPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Contra Conch Piercing UAE | 175 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Contra Conch Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Contra Conch Piercing 175 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={ContraConchPiercingImage} alt="Contra Conch Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Contra Conch Piercing</h3>

          <p>
            Elevate your ear styling with our professional contra conch piercing services in the UAE, available at an affordable price of 175 AED. Contra conch piercing is a stylish and modern cartilage piercing placed opposite the traditional conch area, creating a striking and unique look that instantly enhances your ear aesthetics. This distinctive placement offers a fresh alternative to standard inner-ear piercings, making it perfect for individuals who want to stand out with a bold yet elegant design. Whether you prefer a minimal stud or a small hoop, our expert specialists ensure precise placement for a balanced and visually appealing result that complements your overall style.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each contra conch piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Our goal is to provide a quick, efficient, and pain-minimized procedure, making contra conch piercing suitable for both first-time clients and those looking to expand their ear piercing collection with something unique.
          </p>

          <p>
            Contra conch piercing is ideal for those who want a bold and eye-catching ear design while maintaining a refined look. Its placement allows it to pair beautifully with other ear piercings such as helix, tragus, lobe, or standard conch, helping you create a layered and curated ear style. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your ear structure and personal aesthetic. This personalized approach ensures that your piercing enhances your look in the most flattering way.
          </p>

          <p>
            The procedure is typically completed within minutes, ensuring minimal discomfort and maximum convenience. Our team uses advanced techniques designed to reduce pain and promote faster healing, allowing you to enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can sometimes feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your contra conch piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your contra conch piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our contra conch piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted contra conch piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a striking and modern ear look effortlessly. Book your contra conch piercing appointment today and transform your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Contra Conch Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ContraConchPiercing;